/**
 * Type guard that narrows `T | null | undefined` to `T`.
 * Prefer this over truthy checks when `T` includes falsy values (numbers, empty strings, booleans).
 */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
